import { GraduationCap, ShieldCheck, BookOpen, UserCircle, ArrowRight } from "lucide-react";

const ROLES = [
  {
    id: "admin",
    title: "ผู้ดูแลระบบ",
    subtitle: "System Administrator",
    description: "จัดการข้อมูลอาจารย์ รายวิชา และภาพรวมของระบบสอบออนไลน์",
    icon: ShieldCheck,
    iconBg: "bg-[#007CB7]",
    cardBorder: "border-blue-200 hover:border-[#007CB7]",
    badgeBg: "bg-blue-100 text-[#007CB7]",
    btnClass: "bg-[#007CB7] hover:bg-[#005F8C]",
  },
  {
    id: "teacher",
    title: "อาจารย์ผู้สอน",
    subtitle: "Teacher",
    description: "สร้างข้อสอบออนไลน์ นำเข้าคำถามจากไฟล์ จัดการรายวิชา และดูผลการสอบ",
    icon: BookOpen,
    iconBg: "bg-emerald-600",
    cardBorder: "border-emerald-200 hover:border-emerald-500",
    badgeBg: "bg-emerald-100 text-emerald-700",
    btnClass: "bg-emerald-600 hover:bg-emerald-700",
  },
  {
    id: "student",
    title: "นิสิตผู้เข้าสอบ",
    subtitle: "Student",
    description: "เข้าสอบออนไลน์ ตอบคำถาม และส่งข้อสอบในเวลาที่กำหนด",
    icon: UserCircle,
    iconBg: "bg-purple-600",
    cardBorder: "border-purple-200 hover:border-purple-500",
    badgeBg: "bg-purple-100 text-purple-700",
    btnClass: "bg-purple-600 hover:bg-purple-700",
  },
];

export default function LandingPage({ onSelectRole }) {
  return (
    <div
      className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex flex-col"
      style={{ fontFamily: "'Noto Sans Thai', sans-serif" }}
    >
      {/* Hero Section */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-16">
        {/* Logo & Title */}
        <div className="text-center mb-12 fade-in-up">
          <div className="w-20 h-20 bg-[#007CB7] rounded-2xl flex items-center justify-center mx-auto mb-5 shadow-lg">
            <GraduationCap size={40} color="white" strokeWidth={1.5} />
          </div>
          <h1
            className="text-3xl md:text-4xl font-bold text-[#1A1B1F] mb-2"
            style={{ fontFamily: "'Prompt', sans-serif" }}
          >
            ระบบสอบออนไลน์
          </h1>
          <p className="text-xl font-medium text-[#007CB7] mb-1" style={{ fontFamily: "'Prompt', sans-serif" }}>
            BY PICK
          </p>
          <p className="text-sm text-[#8A92A3]">
            College of Social Communication Innovation, SWU
          </p>
          <div className="w-16 h-1 bg-[#007CB7] rounded-full mx-auto mt-5" />
        </div>

        {/* Subtitle */}
        <p className="text-[#5E636E] text-base mb-10 text-center fade-in-up">
          เลือกประเภทผู้ใช้งานเพื่อเข้าสู่ระบบ
        </p>

        {/* Role Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-4xl">
          {ROLES.map((role, i) => {
            const Icon = role.icon;
            return (
              <div
                key={role.id}
                data-testid={`landing-role-${role.id}`}
                className={`bg-white border-2 ${role.cardBorder} rounded-xl p-8 text-center shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer group fade-in-up`}
                style={{ animationDelay: `${i * 0.1}s` }}
                onClick={() => onSelectRole(role.id)}
              >
                <div className={`w-16 h-16 ${role.iconBg} rounded-2xl flex items-center justify-center mx-auto mb-5 shadow-sm group-hover:scale-110 transition-transform duration-200`}>
                  <Icon size={30} color="white" strokeWidth={1.5} />
                </div>
                <span className={`inline-block text-xs font-semibold px-2.5 py-0.5 rounded-full mb-3 ${role.badgeBg}`}>
                  {role.subtitle}
                </span>
                <h2
                  className="text-xl font-semibold text-[#1A1B1F] mb-3"
                  style={{ fontFamily: "'Prompt', sans-serif" }}
                >
                  {role.title}
                </h2>
                <p className="text-sm text-[#5E636E] leading-relaxed mb-6">
                  {role.description}
                </p>
                <button
                  className={`w-full flex items-center justify-center gap-2 ${role.btnClass} text-white py-2.5 rounded-lg text-sm font-semibold transition-colors shadow-sm`}
                >
                  เข้าระบบ
                  <ArrowRight size={16} strokeWidth={1.5} />
                </button>
              </div>
            );
          })}
        </div>
      </div>

      {/* Footer */}
      <div className="text-center py-5 border-t border-gray-200 bg-white">
        <p className="text-xs text-[#8A92A3]">
          © 2567 วิทยาลัยนวัตกรรมสื่อสารสังคม มหาวิทยาลัยศรีนครินทรวิโรฒ | Online Examination System
        </p>
      </div>
    </div>
  );
}
